






























































import { Vue, Component, Prop } from "vue-property-decorator";
import { ListDisplayMode } from "@/data/constants";
import _ from "@/boot/lodash";
import i18n from "@/i18n";

// Enums/Data
import { LogoSize, LogoType } from "@/data/enums/logos";
import { PurchaseTypes, ProductTypes } from "@/data/enums/products";

// Types
import { IProduct } from "@/models/products";

@Component({
  components: {
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue"),
    "product-list-item": () =>
      import(
        "@/components/app/admin/catalogue/products/listing/productListItem.vue"
      )
  }
})
export default class ProductListItemSwitcher extends Vue {
  // Props

  @Prop({ default: null })
  public product!: IProduct;

  @Prop({ default: ListDisplayMode.GRID })
  public displayMode!: ListDisplayMode;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public itemRouteName!: string;

  @Prop({ default: false })
  public hasProvisioning!: boolean;

  @Prop({ default: i18n.t("_action.manage_product") })
  public action!: boolean;

  // Computed

  public get isGridView() {
    return this.displayMode === ListDisplayMode.GRID;
  }

  public get isInactive() {
    return !this.product.available_for_sales;
  }

  public get provCategoryName() {
    return _.get(this.product, "provision_category.name");
  }

  public get provProviderValue() {
    return _.compact([
      _.get(this.product, "provision_provider.name"),
      _.get(this.product, "provision_configuration.name")
    ]).join(" » ");
  }

  public get provProviderLogoUrl() {
    const logos = _.get(this.product, "provision_provider.logos", []);
    return _.get(
      _.find(logos, logo => {
        if (logo.type === LogoType.ICON && logo.size === LogoSize.ONE_X)
          return true;
        return false;
      }),
      "url",
      null
    );
  }

  public get categoryRouterName() {
    const productType = this.product.product_type;
    if (productType === ProductTypes.PRODUCT_OPTION)
      return "adminCatalogueOptionCategory";
    if (productType === ProductTypes.PRODUCT_ATTRIBUTE)
      return "adminCatalogueAttributeCategory";

    return "adminCatalogueCategory";
  }

  public get availableTerms() {
    return this.$tc(
      "_plurals.available_terms",
      _.uniqBy(this.product.prices, "billing_cycle_months").length
    );
  }

  public get paymentValue() {
    return this.product.billing_cycle_months === PurchaseTypes.RECURRING
      ? `${this.$t("_.recurring")} (${this.availableTerms})`
      : `${this.$t("_.one_off")}`;
  }
}
